export const SURVEY_CATALOG_TYPE = 'survey' as const
export const SURVEY_CATALOG_TITLE_KEY = 'surveyData' as const

export const SURVEY_CATALOG_CONFIG = {
    type: SURVEY_CATALOG_TYPE,
    fixedHeader: true,
    isExistRightToolbar: false,
    treeView: false,
    hideHeader: true,
} as const
